module.exports = __webpack_public_path__ + "static/media/ticket-success.34936a05.svg";